import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab } from '@material-ui/core';
import DynamicTable from '../Components/DynamicTable/DynamicTable';
import NewButton from '../Components/NewComponents/NewButton/NewButton';
import NewConfirmationModal from '../Components/NewComponents/NewConfirmationModal/NewConfirmationModal';
import { useHistory } from 'react-router-dom';
import {fetchAllBanner,deleteBanner} from "../Values/utils"
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router";

const BannerManagement = ({ user }: any) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [banners, setBanners] = useState<any[]>([]);
  const [appBanners, setAppBanners] = useState<any[]>([]);
  const [count, setCount] = useState(0);
  const [appBannerCount, setAppBannerCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [load, setLoad] = useState(false);
  const [showBannerForm, setShowBannerForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedBannerId, setSelectedBannerId] = useState('');
  const [statusChange, setStatusChange] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [isGACalled, setIsGACalled] = useState(false);
  const [showDeleteIntegration,setShowDeleteIntegration]=useState(false)
  const [selectedDataId,setSelectedDataId]=useState("")

  const history=useHistory()
  const dispatcher= useDispatch()
  const location: any = useLocation();

  const headers = 
  tabIndex === 0?[
    {header:"Banner Name",value:"name"},
    { header: 'Content Type', value: 'bannerContentType' },
    { header: 'NavBar', value: 'navBanner' },
    { header: 'Popup', value: 'popup' },
    { header: "Page Banner", value: "pageBanner" },
    { header: "Footer Banner", value: "footerPopup" },
    { header: "ContactSideView Banner", value: "contactSideView" }, 
     {header:"contactMidView Banner", value:"contactMidView"},
    { header: "Page", value: "page" },
    { header: 'Created At', value: 'createdAt' },
    { header: 'Modified At', value: 'updatedAt' },
    { header: 'Created By', value: 'created_by' },
    { header: 'Frequency', value: 'frequency' },
    { header: 'Start Date', value: 'visibleStartDate' },
    { header: 'End Date', value: 'visibleEndDate' },
    { header: 'Day', value: 'visibleByDays' },
    { header: 'Impression GA', value: 'impressionGA' },
    { header: 'CTA GA', value: 'ctaGA' },
    {header:"Banner Status", value:"status"},
  ]:[
    {header:"Banner Name",value:"name"},
    { header: 'Content Type', value: 'bannerContentType' },
    {header:"Below Customer Detail", value:"BelowCustomerDetail"},
    {header:"Below FeedBack Button", value:"BelowFeedBackButton"},
    {header:"Below Lead Stage Box", value:"BelowLeadStageBox"},
    {header:"Page",value:"page"},
    { header: 'Created At', value: 'createdAt' },
    { header: 'Modified At', value: 'updatedAt' },
    { header: 'Created By', value: 'created_by' },
    { header: 'Frequency', value: 'frequency' },
    { header: 'Start Date', value: 'visibleStartDate' },
    { header: 'End Date', value: 'visibleEndDate' },
    { header: 'Day', value: 'visibleByDays' },
    { header: 'Impression GA', value: 'impressionGA' },
    { header: 'CTA GA', value: 'ctaGA' },
    {header:"Banner Status", value:"status"},
    {header:"Banner Platform Type", value:"bannerPlatformType"},
    // {header:"Banner Platform", value:"bannerPlatform"},
  ];

  useEffect(()=>{
    if(location?.state?.tabIndex){
      setTabIndex(location?.state?.tabIndex)
    }
  },[location])
  

   useEffect(() => {
          if (user.bannerRole) {
             fetchAllBanner( (data) => setBanners(data),  setCount, pageSize, page,(data) => setAppBanners(data),  setAppBannerCount);
          }
      }, [user, page, pageSize]);

   useEffect(()=>{
      if(isEdit && editData){
        if(tabIndex ===0){
          history.replace("/AddBanner",{edit:true,data:editData})
        }
        else if(tabIndex ===1){
          history.replace("/AddAppBanner",{edit:true,data:editData})
        }
      }
   },[isEdit,editData])

  return (
    <Box sx={{ width: '85%', padding: 20 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
        <Tabs value={tabIndex}>
          <Tab label="Banner DashBoard" onClick={()=>{
            setTabIndex(0)
          }}/>
          <Tab label="App Banner DashBoard" onClick={()=>{
            setTabIndex(1)
          }}/>
        </Tabs>
        {tabIndex===0?<NewButton
          title="Add Banner"
          onClick={() => history.replace("/AddBanner")}
        />:<NewButton
        title="Add App Banner"
        onClick={() => history.replace("/AddAppBanner")}
      />}
        
      </Box>

      <DynamicTable
       headers={headers}
       data={tabIndex ===0? banners:appBanners}
       page={page}
       setPage={setPage}
       pageSize={pageSize}
       setPageSize={setPageSize}
       count={tabIndex ===0?count:appBannerCount}
       onEdit={(value:any) => {
        setEditData(value)
        setIsEdit(true)
                    
       }}
       onStatusChange={() => {}}
       onDelete={(value:any) => {
        setShowDeleteIntegration(true);
        setSelectedDataId(value);
       }}
       onVerify={() => {}}             
       onFBVerify={() => {}}           
       showVerify={true}               
       integrationTypeNumber={0}
       pannel={"bannerDashBoard"}           
/> 
  <NewConfirmationModal
                title="Delete Banner"
                description="Are you sure you want to delete this Banner ?"
                open={showDeleteIntegration}
                setOpen={setShowDeleteIntegration}
                onSubmit={
                    () => {
                        deleteBanner({Id:selectedDataId,isDelete:true},history,dispatcher,setShowDeleteIntegration)
                    }
                }
            /> 
</Box>

  );
};

const mapStateToProps = (state: any) => {
    return {
      user: state.user.data
    };
  };

export default connect(mapStateToProps)(BannerManagement);
